import Axios from 'axios';
import { url } from 'utils/url';

// Plain API helpers for the Apify hashtag scraper (Media Library).
// Kept out of redux: state is local to the scraper modal.
const auth = () => ({
  Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
});

const unwrap = (p) =>
  p
    .then((r) => r.data)
    .catch((error) => {
      const message =
        error?.response?.data?.message ||
        error?.response?.data?.error ||
        error.message ||
        'Request failed';
      throw new Error(message);
    });

export const getApifyStatus = () =>
  unwrap(Axios.get(`${url}/apify/status`, { headers: auth() }));

export const startScrape = ({
  siteId,
  platform,
  hashtags,
  limit,
  includeVideos,
}) =>
  unwrap(
    Axios.post(
      `${url}/apify/scrape`,
      { siteId, platform, hashtags, limit, includeVideos },
      { headers: auth() }
    )
  );

export const listScrapes = (siteId) =>
  unwrap(
    Axios.post(`${url}/apify/scrape/list`, { siteId }, { headers: auth() })
  );

export const getScrape = ({ siteId, id }) =>
  unwrap(
    Axios.get(`${url}/apify/scrape/get`, {
      params: { siteId, id },
      headers: auth(),
    })
  );

export const abortScrape = ({ siteId, id }) =>
  unwrap(
    Axios.post(`${url}/apify/scrape/abort`, { siteId, id }, { headers: auth() })
  );

export const removeScrape = ({ siteId, id }) =>
  unwrap(
    Axios.post(
      `${url}/apify/scrape/remove`,
      { siteId, id },
      { headers: auth() }
    )
  );

// Thumbnails go through the API (auth header + social CDNs block hotlinking).
export const fetchScrapeThumb = ({ siteId, id, postId }) =>
  Axios.get(`${url}/apify/thumb`, {
    params: { siteId, id, postId },
    headers: auth(),
    responseType: 'blob',
  }).then((r) => r.data);

export const importScrapedPosts = (payload) =>
  unwrap(
    Axios.post(`${url}/apify/import`, payload, {
      headers: auth(),
      timeout: 15 * 60 * 1000,
    })
  );
